import React from 'react';
import './HeaderSearchResult.css';
import {useNavigate} from "react-router-dom";

const HeaderSearchResult = React.forwardRef(({ item, onPicked }, ref) => {
    const navigate = useNavigate();

    const handleClick = () => {
        // optional: let parent close + clear
        onPicked?.();
        const productPath = item.handle
            ? `/produkt/${item.handle}`
            : `/produkt?id=${encodeURIComponent(item.id)}`;
        navigate(productPath.startsWith('/') ? productPath : `/${productPath}`);
    };

    return (
        <div
            ref={ref}
            className="header-search-result"
            onClick={handleClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleClick(); }}
        >
            <div className="header-search-result-image">
                <img loading="lazy" src={item.imageUrl} alt={item.alt || item.name || 'Produkt'} />
            </div>
            <div className="header-search-result-name">{item.name}</div>
            <div className="header-search-result-price">
                {(item.price).toFixed(2)} {item.currency}
            </div>
        </div>
    );
});

export { HeaderSearchResult };
export default HeaderSearchResult;
